import React from 'react'

import styles from './styles.module.scss'

const CloseButton: React.FC<React.HTMLProps<HTMLButtonElement>> = (props) => {
  return (
    <button {...props} aria-label="close-button" className={styles.closeBtn} type="button">
      <div className={styles.xUp}>
        <div className={styles.xDown} />
      </div>
    </button>
  )
}

export default CloseButton
